<template>
	<div id="topgamelist">
		<div class="content">
			<div class="plat-div">
				<img loading="lazy" v-lazy="require('../../assets/images/amjs/top-list-left'+size+'.png')">
			</div>
			<!-- <div v-if="type == 3 || type == 2" class="bac">
				<ul class="ul">
					<li v-for="(item,index) in list" :key = "index" class="rowli">
						<div class="item-row" @click="gotoSub(item)">
							<img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:defaultImg" @error="defImg()" class="item-row-img"/>
							<div class="item-row-title">{{item.name}}</div>
						</div>
					</li>
				</ul>
			</div> -->
			
			<div class="bac">
				<ul :class="type==1||type==4 ? 'ul' : 'ul other'">
					<template v-for="(item,index) in list">
						<li :key="index" class="defaultli" v-if="item.nameEn!='fishing'">
							<div class="item" @click="gotoSub(item)">
								<img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:defaultImg" @error="defImg()" class="item-img"/>
								<div class="item-title">{{item.name}}</div>
							</div>
						</li>
					</template>
				</ul>
			</div>
		</div>
			
	</div>
</template>

<script>
	// import './topGameMenu.scss'
	
	export default {
		props:{
			type:Number,//2 3大图 左右布局 1 4小图上下布局
			list:Array,
			size:Number,
			default:Number,
		},
		data(){
			return {
				gameUrl:'',
				userId:'',
				userName:'',
				tenetid:'',
				defaultImg:require('@/assets/images/mb/default-hot.png'),
				default_list:[
					{img:require('@/assets/images/mb/chess-default-header.png')}, // 棋牌
					{img:require('@/assets/images/mb/lottery-default-header.png')}, // 彩票
					{img:require('@/assets/images/mb/esports-default-header.png')}, // 电竞
					{img:require('@/assets/images/mb/sport-default-header.png')}, // 体育
					{img:require('@/assets/images/mb/live-default-header.png')}, // 真人
				],
			}
		},
		created() {
			if(this.default != undefined){
				this.defaultImg = this.default_list[this.default].img
			}
			if (this.$common.getUser()) {
			  this.userId = this.$common.getUser().user_id
			  this.userName = this.$common.getUser().username
			  this.tenetid = this.$common.getUser().tenant_id
			}
		},
		methods:{
			defImg(){
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			//
			gotoSub(item){
				//二级界面
				if (this.type == 1){
					localStorage.setItem('casinoCur',JSON.stringify(item))
					this.$router.push({
						path:'/egame',
						query:{
							id:item.id
						}
					})
					
				}else if(this.type == 2){
					localStorage.setItem('chessCur',JSON.stringify(item))
					this.$router.push({
						path:'/chess',
						query:{
							id:item.id
						}
					})
				}else {//直接进入游戏
					if (this.$common.isLogin()){
						if(this.type == 4){
							this.getToken(item,1)
						}else{
							this.getToken(item,2)
						}
					}else {
						// this.$common.showLogin()
						this.$message.warning(this.$t('indexPage.pleaseLogin'))
					}
				}
			},
			// 进入游戏
			getToken: async function(req,index) {
				// return
				let self = this;
					var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
					
				if (!self.$common.getUser()) {
					self.$message.warning(self.$t('indexPage.pleaseLogin'))
					return
				}
				self.tenantId = self.$common.getUser().tenant_id
				self.username = self.$common.getUser().username
				self.uid = self.$common.getUser().user_id
				let datas = {
					tenantId: self.tenantId,
					username: self.username,
					gameId: index == 2?req.ids:req.id,
					clientIp: self.$config.clientIp,
					memberId: self.uid,
					terminalType: 1
				}
				self.$common.setGameRequestData(datas)
				
				const res = await self.$http.post(this.$api.getToken, datas, true)
				if (res.code == 0) {
					self.gameUrl = res.data;
					if (req.openMode === 1) {
					// if(issafariBrowser) {
						//  self.winOpen.location.href = self.gameUrl;
					// }else{
						window.open(self.gameUrl)
					// }
					
					}else{
						window.open(self.gameUrl)
					}

				} else {
					self.$message.error(self.$t('indexPage.repair'))
					// if (req.openMode === 1) {
					// window.open('/error.html?type=1')
					// // self.winOpen.location.href = '/error.html?type=1';
					// }
					
					// if (req.status === 0) {
					//     self.$message.error(self.$t('indexPage.repair'))
					// }else{
					//     self.$message.error(self.$t('indexPage.failed'))
					// }
				}
			},
			async enterGame(item, fromActivity) {
			  //获取游戏链接
			  var _this = this
			  var data = {
			    tenantId: _this.tenetid,
			    username: _this.userName,
			    vendorId: fromActivity ? item.bannerGame.vendorId : item.vendorId,
			    gameId: fromActivity ? item.bannerGame.id : item.id,
			    clientIp: _this.$config.clientIp,
			    memberId: _this.userId,
			    terminalType: 1
			  }
			  _this.$common.setGameRequestData(data)
			  var res = await _this.$http.post(_this.$api.getTokenUrl, data, true)
			  if (res.code == 0) {
			    _this.gameUrl = res.data
			    _this.$store.commit('isShow', '8')
			    _this.$store.commit('windowgame', true)
			    _this.$store.commit('showGame', true)
			    _this.$store.commit('exitLogin', true)
			    let str = res.data
			    let newType = str.slice(0, 4)
			    let linkType = null
			    if (newType === 'http') {
			      linkType = 1
			    } else if (newType === '<!do') {
			      linkType = 2
			    } else {
			      linkType = 3
			    }
			    _this.$common.setWebView(
			      _this.gameUrl,
			      fromActivity ? item.bannerGame.name : item.name,
			      linkType
			    )
			
			    this.$emit('disappear', 8)
			    _this.$router.push({
			      name: 'WebView'
			    })
			    this.$store.commit('hideAside', true)
			
			    //
			    if (this.$store.state.actBannerEnterGame) {
			      _this.$store.commit('actBannerEnterGame', null)
			    }
			  } else {
			    _this.$message.error('维护中')
			  }
			},
			
		},
		
	}
</script>
<style lang="scss" scoped>
#topgamelist {
	max-height: 400px;
    overflow-y: scroll;
	.content {
		width: 1050px;
		margin: 0 auto;
		padding: 20px 0;
		display: flex;
		justify-content:space-between;
		.plat-div {
			img {
				height: 193px;
			}
		}
		.bac {
			width: 840px;
			ul {
				display: flex;
    			flex-wrap: wrap;
				li {
					width: 105px;
					margin-bottom: 20px;
					text-align: center;
					cursor: pointer;
					color: #fff;
					&:hover {
						color: #ffff7b;
						.item-img {
							transform: scale(1.1);
						}
					}
					.item {
						.item-img {
							height: 42px;
							margin-bottom: 5px;
							transition: all .2s;
						}
						.item-title {
							font-size: 14px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					}
				}
				&.other {
					li {
						width: 210px;
						.item {
							.item-img {
								height: 150px;
							}
						}
					}
				}
			}
		}
	}
}
</style>

